import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { TiThMenu } from "react-icons/ti";
import { MdOutlineClose } from "react-icons/md";
import logo from "../assests/Images/PPT_Logo.png";
import { IoMdArrowDropdown } from "react-icons/io";
import useIsMobile from "../core/hooks/isMobile";

const Navbar = () => {
  const Mobile = useIsMobile();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  return (
    <>
      <header className="fixed top-0 left-0 w-full z-50">
        <nav className="bg-white border-b border-gray-200 shadow-sm">
          <div className="max-w-7xl mx-auto px-4 lg:px-8 h-16 flex items-center justify-between">
            {/* LOGO */}
            <NavLink to="/" className="flex-shrink-0">
              <img src={logo} alt="Logo" className="h-10 w-auto" />
            </NavLink>

            {!Mobile && (
              <>
                <div className="hidden md:flex items-center gap-8 text-gray-800 font-medium">
                  <NavLink
                    to="/"
                    className={({ isActive }) =>
                      isActive
                        ? "text-primary font-semibold"
                        : "hover:text-primary"
                    }
                  >
                    Home
                  </NavLink>

                  <Menu as="div" className="relative">
                    <MenuButton className="flex items-center gap-1 hover:text-primary">
                      About Us <IoMdArrowDropdown />
                    </MenuButton>

                    <MenuItems className="absolute left-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-50">
                      {[
                        { to: "/overview", label: "Overview" },
                        { to: "/meet-our-team", label: "Meet Our Team" },
                        { to: "/aspiring-minds", label: "Aspiring Minds" },
                        { to: "/productivity", label: "Productivity" },
                        { to: "/stratrgic-HR", label: "Strategic HR" },
                      ].map((item, i) => (
                        <MenuItem key={i}>
                          <NavLink
                            to={item.to}
                            className={({ isActive }) =>
                              `block px-4 py-2 text-sm ${
                                isActive
                                  ? "bg-primary text-white"
                                  : "hover:bg-gray-100"
                              }`
                            }
                          >
                            {item.label}
                          </NavLink>
                        </MenuItem>
                      ))}
                    </MenuItems>
                  </Menu>

                  <NavLink
                    to="/staffing"
                    className={({ isActive }) =>
                      isActive
                        ? "text-primary font-semibold"
                        : "hover:text-primary"
                    }
                  >
                    Staffing
                  </NavLink>

                  <NavLink
                    to="/indigis-enterprise"
                    className={({ isActive }) =>
                      isActive
                        ? "text-primary font-semibold"
                        : "hover:text-primary"
                    }
                  >
                    Indigis
                  </NavLink>
                </div>

                {/* CTA */}
                <NavLink to="/contact-us">
                  <button className="hidden md:block bg-primary text-white px-5 py-2 rounded-md font-semibold hover:bg-primary/90 transition">
                    Contact Us
                  </button>
                </NavLink>
              </>
            )}

            {Mobile && (
              <Menu>
                {({ open }) => {
                  if (open !== isMenuOpen) setIsMenuOpen(open);

                  return (
                    <>
                      <MenuButton>
                        {open ? (
                          <MdOutlineClose className="text-3xl text-primary" />
                        ) : (
                          <TiThMenu className="text-3xl text-primary" />
                        )}
                      </MenuButton>

                      {open && (
                        <MenuItems className="absolute top-full left-0 w-full bg-white border-t border-gray-200 shadow-lg flex flex-col p-5 gap-4 z-40">
                          {[
                            { to: "/", label: "Home" },
                            { to: "/staffing", label: "Staffing" },
                            { to: "/indigis-enterprise", label: "Indigis" },
                          ].map((item, i) => (
                            <MenuItem key={i}>
                              <NavLink
                                to={item.to}
                                className="text-gray-800 font-medium"
                              >
                                {item.label}
                              </NavLink>
                            </MenuItem>
                          ))}

                          <div className="border-t pt-3">
                            <p className="text-sm font-semibold text-gray-500 mb-2">
                              About Us
                            </p>
                            <div className="flex flex-col gap-2">
                              <NavLink to="/overview">Overview</NavLink>
                              <NavLink to="/meet-our-team">
                                Meet Our Team
                              </NavLink>
                              <NavLink to="/aspiring-minds">
                                Aspiring Minds
                              </NavLink>
                              <NavLink to="/productivity">Productivity</NavLink>
                              <NavLink to="/stratrgic-HR">Strategic HR</NavLink>
                            </div>
                          </div>

                          <NavLink to="/contact-us">
                            <button className="mt-4 w-full bg-primary text-white py-2 rounded-md font-semibold">
                              Contact Us
                            </button>
                          </NavLink>
                        </MenuItems>
                      )}
                    </>
                  );
                }}
              </Menu>
            )}
          </div>
        </nav>
      </header>
    </>
  );
};

export default Navbar;
